"use strict";
/*
 * Account Retrievers - DATA ACCESS WITHOUT ANY STATE CHANGE
 *
 * This provides global access to the accounts.
 *
 * WARNING: These should NEVER be used for properties (MapToProps).  These are to retrieve information from
 * the REDUX Store and perform operations/searches on it, but this will not create any linkage for state change
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencyString = exports.getAccountString = exports.getAccountById = exports.getAccountsByIdIncludingGoals = exports.getAccountsById = void 0;
const redux_store_1 = __importDefault(require("companion-app-components/utils/redux-store"));
const accounts_1 = require("companion-app-components/flux/accounts");
function getAccountsById(s = redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState()) {
    return accounts_1.accountsSelectors.getAccountsById(s);
}
exports.getAccountsById = getAccountsById;
function getAccountsByIdIncludingGoals(s = redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState()) {
    return accounts_1.accountsSelectors.getAccountsByIdIncludingGoals(s);
}
exports.getAccountsByIdIncludingGoals = getAccountsByIdIncludingGoals;
function getAccountById(id, s = redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState()) {
    const accounts = accounts_1.accountsSelectors.getAccountsByIdIncludingGoals(s);
    return accounts.get(id);
}
exports.getAccountById = getAccountById;
function getAccountString(id, s = redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState()) {
    const account = getAccountById(id, s);
    if (account) {
        return account.name;
    }
    return '[Account Not Synced]';
}
exports.getAccountString = getAccountString;
function getCurrencyString(id, s = redux_store_1.default === null || redux_store_1.default === void 0 ? void 0 : redux_store_1.default.getState()) {
    const account = getAccountById(id, s);
    if (account) {
        return account.currency;
    }
    return 'N/A';
}
exports.getCurrencyString = getCurrencyString;
